<template>
  <div>
    <v-container
      fluid
      class="px-12"
    >
      <v-row>
        <v-col
          cols="12"
          class="text-center"
        >
          <img
            contain
            src="/static/gamboa-logo.svg"
            height="150px"
            class="mx-0 pt-0 text-left"
          >
        </v-col>
        <v-col
          cols="12"
          md="10"
          offset-md="1"
          class="px-12 pt-8 text-center"
          justify="center"
        >
          <p>
            {{ $t("home.paragraph1") }}
          </p>
          <p>
            {{ $t("home.paragraph2") }}
          </p>
          <p>
            {{ $t("home.paragraph3") }}
          </p>
          <p>
            {{ $t("home.paragraph4") }}
          </p>
        </v-col>
      </v-row>
    </v-container>

    <!-- members section -->
    <section class="grey lighten-3 pb-0">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            justify="center"
            align="center"
            class="pt-0 pb-12"
          >
            <span class="display-1">
              {{ $t("home.team_title") }}
            </span>
          </v-col>
        </v-row>
        <v-row
          justify="center"
          align="center"
        >
          <v-col
            v-for="(member, index) in team"
            :key="member.name + index"
            cols="12"
            md="4"
            class="text-center pb-12"
          >
            <!-- <v-hover v-slot:default="{ hover }"> -->
            <v-avatar
              size="200"
            >
              <v-img
                :src="member.img"
                :alt="member.name"
              >
                <!-- <v-expand-transition>
                  <div
                    v-if="hover"
                    class="transition-fast-in-fast-out primary darken-2 v-card--reveal display-3 white--text"
                    style="height: 100%; width: 100%;"
                  >
                    <div style="margin-top: 60px;"></div>
                    +info
                  </div>
                </v-expand-transition> -->
              </v-img>
            </v-avatar>
            <!-- </v-hover> -->
            <br><br>
            <span class="title">{{ member.name }}</span>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- services parallax section -->
    <section class="white pt-0">
      <v-parallax
        dark
        src="/static/FondoServicios.jpg"
        height="300"
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            class="text-center"
            cols="12"
            md="6"
          >
            <h1 class="display-1 font-weight-thin mb-4">
              {{ $t("home.services_title") }}
            </h1>
            <h4 class="subheading">
              {{ $t("home.services_description") }}
            </h4>
          </v-col>
        </v-row>
      </v-parallax>
    </section>

    <!-- services section -->
    <section class="white">
      <v-container>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            v-for="service in this.$store.state.services"
            :key="service.name"
            cols="12"
            md="3"
          >
            <v-card
              max-width="344"
              class="mx-auto"
              outlined
            >
              <v-img
                :src="service.img"
                height="194"
                class="white--text align-end"
              >
                <p
                  class="headline text-right pr-4 mb-0"
                  style="text-shadow: 2px 2px 2px #000"
                  v-text="!$store.state.langSwitch ? service.name : service.nameEn"
                />
              </v-img>
              <!--              <v-card-text-->
              <!--                class="text-center"-->
              <!--                v-text="!$store.state.langSwitch ? service.description : service.descriptionEn"-->
              <!--              />-->
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
  export default {
    metaInfo () {
      return {
        title: 'Creative'
      }
    },
    data: () => ({
      team: [
        {
          name: 'Julio Gamboa Cornu',
          level: 'Socio',
          img: '/static/Julio2.png'
        },
        {
          name: 'Felipe Gamboa Lavados',
          level: 'Asociado',
          img: '/static/Felipe1.png'
        }
      ],
      lazyIsActive: false
    })
  }
</script>
